import React from "react";
import {
    Navigate,
} from "react-router-dom";

const BulkImportComponent = React.lazy(() => import("../../../../../components/bulk-import/components/list/page"));

export const importRoutes = [
    {
        path: 'list',
        element: <BulkImportComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/stockify/import/list" />
    },
];